/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { skillSchema } from './skillSchema';

export const pageResponseSkillSchema = z.object({
  cursor: z.string().nullish(),
  get data() {
    return z.array(skillSchema);
  },
  hasNextPage: z.boolean().nullish(),
  recordCount: z.int().nullish(),
  recordLimit: z.int().nullish(),
});
